import {
    apiRequest,
    PengaturanMenuList,
    PengaturanMenuActive,
    PengaturanMenuInactive
} from "../../../../../services/adapters/kepegawaian/menuService"

class DataTableRepository {

    fetchRowTable = async (query, cancelToken) => {
        return await apiRequest("get", PengaturanMenuList, {
            cancelToken: cancelToken,
            params: query
        }, true)
    }

    fetchInactive = async (query) => {
        return await apiRequest("post", PengaturanMenuInactive, {
            body: query
        }, true)
    }

    fetchActive = async (query) => {
        return await apiRequest("post", PengaturanMenuActive, {
            body: query
        }, true)
    }
}

export default DataTableRepository